import * as React from 'react';
import styled from 'styled-components';

import { useAppSelector } from '@/redux/hooks';
import { getItemSummaryFirstImageUrl, getNextItemSummary } from '@/redux/modules/item/summary/itemSummary.selectors';
import { addImageParams } from '@/utils/urls';

type Props = {
    itemId: number;
    width?: number;
};

/**
 * Preloads the first image for the next item in the auction
 */
const NextItemImagePreloader = ({ itemId, width = 1024 }: Props) => {
    const { itemId: nextItemId } = useAppSelector((state) => getNextItemSummary(state, itemId));
    const url = useAppSelector((state) => getItemSummaryFirstImageUrl(state, nextItemId));
    const imageUrl = addImageParams({ url, width });

    if (nextItemId) {
        return (
            <Container>
                <img
                    data-testid="next-item-image-preloader"
                    src={imageUrl}
                />
            </Container>
        );
    }

    return null;
};

export default NextItemImagePreloader;

const Container = styled.div`
    height: 0;
    overflow: hidden;
    visibility: hidden;
    width: 0;
`;
